export type EmployeeFormFieldType = 'date' | 'text';
export type EmployeeFormFieldGroup = 'professional' | 'ceu' | 'other';
export type EmployeeFormFieldSource = 'native' | 'custom';

export interface EmployeeFormSchemaField {
  key: string;
  label: string;
  type: EmployeeFormFieldType;
  group: EmployeeFormFieldGroup;
  source: EmployeeFormFieldSource;
  order: number;
  has_expiration: boolean;
  is_system: boolean;
}

export interface EmployeeFormSchema {
  professional: EmployeeFormSchemaField[];
  ceu: EmployeeFormSchemaField[];
  other: EmployeeFormSchemaField[];
}
